module.exports = __webpack_public_path__ + "static/img/me_img_default@2x.1.e7c49d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/chatPlaza/img/me_img_default@2x.1.png
// module id = QH1A
// module chunks = 8